<script lang="ts" generics="ITEM">
    import type {SearchParams, Sorting, ViewableSearch} from 'typings/portaro.be.types';
    import type {Observable} from 'rxjs';
    import {getSearchContext} from '../kp-search-context/search-context';
    import {findFirst, byId} from 'shared/utils/array-utils';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import SearchToolbarSection from './SearchToolbarSection.svelte';

    const searchManager = getSearchContext<ITEM>();
    $: hasAnySortings = exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('sorting') && $lastSearch.availableSortings.length > 1;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    let selectedSorting: Sorting;
    $: if (exists($lastSearch) && exists(searchManager.getFrontendParams()?.sorting)) {
        selectedSorting = findFirst($lastSearch.availableSortings, byId(searchManager.getFrontendParams().sorting.id));
    }

    function onSortingChange(sorting: Sorting) {
        searchManager.newSearchWithPartialParams({sorting});
    }
</script>

{#if hasAnySortings}
    <SearchToolbarSection icon="list" title="Řazení dle">
        {#each $lastSearch.availableSortings as sorting}
            <button class="sorting-item"
                    on:click={() => onSortingChange(sorting)}
                    class:sorting-selected={sorting === selectedSorting}>

                {pipe(sorting, loc())}
            </button>
        {/each}
    </SearchToolbarSection>
{/if}

<style lang="less">
    .sorting-item {
        padding: 0;
        margin: 0;
        background: none;
        border: none;
        outline: none;
        cursor: pointer;

        &.sorting-selected {
            font-weight: 500;
            color: var(--accent-blue-new);
        }
    }
</style>